<template>
  <div class="home-testimonials-parent">
    <article class="home-testimonials-child">

      <section class="home-testimonials-title">
<!--        <img src="@/assets/images/Home_Testimonial_Asset_L.png" alt="">-->
        <h1>{{ $t('home-page.testimonials-saying') }}</h1>
<!--        <img src="@/assets/images/Home_Testimonial_Asset_R.png" alt="">-->
      </section>

      <section class="home-testimonials-user-parent">
        <div class="top-border"></div>
        <div class="home-testimonials-user-child">
          <h2>{{ $t('home-page.testimonials-user-name') }}</h2>
          <span>{{ userSource }} {{ $t('home-page.testimonials-user-title') }}</span>
          <hr class="home-testimonials-hr">
          <p>{{ $t('home-page.testimonials-paragraph') }}</p>
          <img src="@/assets/images/Home_Testimonial_Asset_SVG.svg" alt="">
        </div>
      </section>
    </article>

    <article class="home-testimonials-child stories">
      <div class="home-testimonials-link">

        <a href="https://twitter.com/seedrcoil">{{ $t('actions.more-stories') }}</a>
      </div>
    </article>

  </div>
</template>

<script>
export default {
  name: 'HomeTestimonials',
  props: {
    msg: String
  },
  data() {
    return {
      userSource: 'Facebook'
    }
  }
  }
</script>

<style scoped lang="scss">

</style>
